<template lang="pug">
div
  v-card.faq-card.pa-3(v-show="ativo", outlined)
    .d-flex.mb-0
      v-text-field.mt-1.mr-2(
        v-model="busca",
        label="Pesquisar categorias, seções e artigos",
        prepend-inner-icon="mdi-magnify",
        outlined,
        dense,
        clearable
      )

      v-menu(
        v-if="podeEditar",
        offset-y,
        :disabled="carregandoCategorias || Boolean(erroCategorias)"
      )
        template(v-slot:activator="{ on, attrs }")
          v-btn.faq-btn-action.text-none.mb-2.mt-2(
            v-bind="attrs",
            v-on="on",
            outlined,
            :disabled="carregandoCategorias || Boolean(erroCategorias)"
          )
            v-icon(left) mdi-plus
            span Adicionar
            v-icon(right) mdi-chevron-down
        v-list(dense)
          v-list-item(@click="novaCategoria()")
            v-list-item-title Nova categoria
          v-list-item(:disabled="!categorias.length", @click="novaSecao()")
            v-list-item-title Nova seção
    .text-center.pa-6(
      v-if="carregandoCategorias",
      role="status",
      aria-live="polite"
    )
      v-progress-circular(indeterminate, color="primary", size="28")
      p.mt-3.mb-0 Carregando categorias e seções...
    v-alert.mt-3(
      v-else-if="erroCategorias",
      type="error",
      outlined,
      role="alert"
    )
      div {{ erroCategorias }}
      v-btn.mt-2(text, small, @click="carregarCategorias") Tentar novamente
    v-list.faq-list.faq-categorias-list(v-else)
      div(
        v-for="(categoria, index) in categoriasFiltradas",
        :key="categoria.id"
      )
        v-divider(v-if="index > 0")
        v-list-item(
          :link="categoriaTemSecoes(categoria)",
          @click="alternarCategoria(categoria)"
        )
          v-list-item-content
            v-tooltip(
              content-class="faq-tooltip",
              bottom,
              open-on-hover,
              max-width="400",
              :disabled="!categoria.descricao"
            )
              template(v-slot:activator="{ on, attrs }")
                v-list-item-title
                  faq-status.mr-2(:status="categoria.status")
                  span(v-bind="attrs", v-on="on") {{ categoria.titulo }}
              span {{ categoria.descricao }}
          v-list-item-action
            .d-flex.align-center
              v-tooltip(v-if="podeEditar", content-class="faq-tooltip", bottom)
                template(v-slot:activator="{ on, attrs }")
                  v-btn(
                    v-bind="attrs",
                    v-on="on",
                    icon,
                    small,
                    color="success",
                    aria-label="Incluir seção nesta categoria",
                    @click.stop="novaSecao(categoria)"
                  )
                    v-icon(small) mdi-plus
                span Incluir seção nesta categoria
              v-tooltip(v-if="podeEditar", content-class="faq-tooltip", bottom)
                template(v-slot:activator="{ on, attrs }")
                  v-btn(
                    v-bind="attrs",
                    v-on="on",
                    icon,
                    small,
                    color="primary",
                    aria-label="Editar categoria",
                    @click.stop="editarCategoria(categoria)"
                  )
                    v-icon(small) mdi-pencil
                span Alterar categoria
              v-tooltip(v-if="podeEditar", content-class="faq-tooltip", bottom)
                template(v-slot:activator="{ on, attrs }")
                  span(v-bind="attrs", v-on="on", style="display: inline-flex")
                    v-btn(
                      icon,
                      small,
                      color="error",
                      :disabled="categoriaTemSecoes(categoria)",
                      aria-label="Excluir categoria",
                      @click.stop="solicitarExclusaoCategoria(categoria)"
                    )
                      v-icon(small) mdi-delete
                span {{ categoriaTemSecoes(categoria) ? "Exclua as seções antes de remover a categoria" : "Excluir categoria" }}
              v-icon {{ categoria.secoes.length && categoriaExpandida(categoria) ? "mdi-chevron-up" : "mdi-chevron-down" }}
        template(v-if="!categoriaTemSecoes(categoria)")
          v-divider.ml-10
          v-list-item
            v-list-item-content
              v-list-item-title.grey--text.text-center.font-italic Nenhuma seção cadastrada
        template(v-if="categoriaExpandida(categoria)")
          div(v-for="secao in categoria.secoes", :key="secao.id")
            v-divider.ml-10
            v-list-item.pl-10(link, @click="alternarSecao(secao)")
              v-list-item-content
                v-tooltip(
                  content-class="faq-tooltip",
                  bottom,
                  open-on-hover,
                  max-width="400",
                  :disabled="!secao.descricao"
                )
                  template(v-slot:activator="{ on, attrs }")
                    v-list-item-title
                      faq-status.mr-2(:status="secao.status")
                      span(v-bind="attrs", v-on="on") {{ secao.titulo }}
                  span {{ secao.descricao }}
              v-list-item-action
                .d-flex.align-center
                  v-tooltip(
                    v-if="podeEditar",
                    content-class="faq-tooltip",
                    bottom,
                    open-on-hover,
                    open-on-focus
                  )
                    template(v-slot:activator="{ on, attrs }")
                      v-btn(
                        v-bind="attrs",
                        v-on="on",
                        icon,
                        small,
                        color="success",
                        aria-label="Adicionar artigos à seção",
                        @click.stop="abrirDialogAnexarArtigos(secao)"
                      )
                        v-icon(small) mdi-link-plus
                    span Adicionar artigos à seção
                  v-tooltip(
                    v-if="podeEditar",
                    content-class="faq-tooltip",
                    bottom,
                    open-on-hover,
                    open-on-focus
                  )
                    template(v-slot:activator="{ on, attrs }")
                      v-btn(
                        v-bind="attrs",
                        v-on="on",
                        icon,
                        small,
                        color="primary",
                        aria-label="Editar seção",
                        @click.stop="editarSecao(categoria, secao)"
                      )
                        v-icon(small) mdi-pencil
                    span Editar seção
                  v-tooltip(v-if="podeEditar", content-class="faq-tooltip", bottom)
                    template(v-slot:activator="{ on, attrs }")
                      span(
                        v-bind="attrs",
                        v-on="on",
                        style="display: inline-flex"
                      )
                        v-btn(
                          icon,
                          small,
                          color="error",
                          :disabled="secaoTemArtigos(secao)",
                          aria-label="Excluir seção",
                          @click.stop="solicitarExclusaoSecao(secao)"
                        )
                          v-icon(small) mdi-delete
                    span {{ secaoTemArtigos(secao) ? "Remova os artigos vinculados antes de excluir a seção" : "Excluir seção" }}
                  v-icon {{ secaoExpandida(secao) ? "mdi-chevron-up" : "mdi-chevron-down" }}
            template(v-if="secaoExpandida(secao)")
              div(v-for="artigo in artigosOrdenados(secao)", :key="artigo.id")
                v-divider.ml-16
                v-list-item.faq-article.pl-16(
                  link,
                  @click="$emit('visualizar', artigo)"
                )
                  v-list-item-icon
                    faq-status(:status="artigo.status")
                  v-list-item-content
                    v-tooltip(
                      content-class="faq-tooltip",
                      bottom,
                      open-on-hover,
                      max-width="400",
                      :disabled="!artigo.descricao"
                    )
                      template(v-slot:activator="{ on, attrs }")
                        v-list-item-title
                          span(v-bind="attrs", v-on="on") {{ artigo.titulo }}
                      span {{ artigo.descricao }}
                  v-list-item-action
                    .d-flex.align-center
                      v-tooltip(
                        v-if="podeEditar",
                        content-class="faq-tooltip",
                        bottom,
                        open-on-hover,
                        open-on-focus
                      )
                        template(v-slot:activator="{ on, attrs }")
                          v-btn(
                            v-bind="attrs",
                            v-on="on",
                            icon,
                            small,
                            color="error",
                            aria-label="Remover artigo da seção",
                            @click.stop="solicitarExclusaoArtigo(secao, artigo)"
                          )
                            v-icon(small) mdi-link-off
                        span Remover artigo da seção
              v-divider.ml-16(v-if="!secaoTemArtigos(secao)")
              v-list-item.faq-empty-articles(v-if="!secaoTemArtigos(secao)")
                v-list-item-content
                  v-list-item-title.text-center.grey--text.font-italic Nenhum artigo
      v-list-item(v-if="categoriasFiltradas.length === 0")
        v-list-item-content
          v-list-item-title.text-center.grey--text.font-italic {{ busca ? "Nenhum resultado encontrado" : "Nenhuma categoria cadastrada" }}
    .faq-categorias-footer.d-flex.align-center
      v-btn.faq-btn-action.text-none.mr-2(
        outlined,
        small,
        aria-label="Expandir tudo",
        :disabled="carregandoCategorias || Boolean(erroCategorias) || Boolean(normalizarTexto(busca))",
        @click="expandirTudo()"
      )
        v-icon(left, small) mdi-unfold-more-horizontal
        span Expandir
      v-btn.faq-btn-action.text-none(
        outlined,
        small,
        aria-label="Recolher tudo",
        :disabled="carregandoCategorias || Boolean(erroCategorias) || Boolean(normalizarTexto(busca))",
        @click="recolherTudo()"
      )
        v-icon(left, small) mdi-unfold-less-horizontal
        span Recolher

  //- Dialog Confirmar Exclusão de Categoria
  v-dialog(
    :value="dialogConfirmacaoExclusaoCategoria",
    @input="dialogConfirmacaoExclusaoCategoria = $event",
    persistent,
    max-width="500"
  )
    v-card.faq-card(outlined)
      v-card-title.faq-dialog-header Excluir categoria
      v-card-text.pt-6
        p.mb-0
          | Tem certeza que deseja excluir a categoria
          strong {{ categoriaExclusaoPendente && categoriaExclusaoPendente.titulo }}?
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          @click="cancelarExclusaoCategoria()",
          :disabled="excluindoCategoria"
        ) Cancelar
        v-btn.text-none(
          color="error",
          small,
          @click="confirmarExclusaoCategoria()",
          :loading="excluindoCategoria",
          :disabled="excluindoCategoria"
        ) Excluir categoria

  //- Dialog Incluir/Editar Categoria
  v-dialog(
    :value="dialogCategoria",
    @input="dialogCategoria = $event",
    persistent,
    max-width="600"
  )
    v-card.faq-card(outlined)
      v-card-title.faq-dialog-header {{ categoriaManipulate.id !== null ? "Editar categoria" : "Nova categoria" }}
      v-card-text.pt-6
        .d-flex.justify-center.align-center.py-8(
          v-if="carregandoEdicaoCategoria",
          role="status"
        )
          v-progress-circular(indeterminate, color="primary")
          span.ml-4 Carregando categoria...
        v-form#faq-form-categoria(v-else, @submit.prevent="salvarCategoria()")
          v-text-field(
            :value="categoriaManipulate.nome",
            @input="categoriaManipulate.nome = $event",
            label="Nome da categoria",
            :disabled="salvandoCategoria",
            outlined,
            dense
          )
          v-textarea(
            :value="categoriaManipulate.descricao",
            @input="categoriaManipulate.descricao = $event",
            label="Descrição",
            :disabled="salvandoCategoria",
            outlined,
            dense,
            rows="3",
            auto-grow
          )
          v-select(
            v-model="categoriaManipulate.status",
            :items="opcoesStatusCategoria",
            label="Status",
            :disabled="salvandoCategoria",
            outlined,
            dense
          )
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          @click="fecharCategoria()",
          :disabled="salvandoCategoria"
        ) Cancelar
        v-btn.faq-btn-primary.text-none(
          color="primary",
          small,
          type="submit",
          form="faq-form-categoria",
          :loading="salvandoCategoria",
          :disabled="salvandoCategoria || carregandoEdicaoCategoria"
        ) Salvar

  //- Dialog Incluir/Editar Seção
  v-dialog(
    :value="dialogSecao",
    @input="dialogSecao = $event",
    persistent,
    max-width="600"
  )
    v-card.faq-card(outlined)
      v-card-title.faq-dialog-header {{ secaoManipulate.id !== null ? "Editar seção" : "Nova seção" }}
      v-card-text.pt-6
        .d-flex.justify-center.align-center.py-8(
          v-if="carregandoEdicaoSecao",
          role="status"
        )
          v-progress-circular(indeterminate, color="primary")
          span.ml-4 Carregando seção...
        v-form#faq-form-secao(v-else, @submit.prevent="salvarSecao()")
          v-text-field(
            :value="secaoManipulate.nome",
            @input="secaoManipulate.nome = $event",
            label="Nome da seção",
            :disabled="salvandoSecao",
            outlined,
            dense
          )
          v-select(
            :value="secaoManipulate.categoriaId",
            @input="secaoManipulate.categoriaId = $event",
            :items="categorias",
            item-text="titulo",
            item-value="id",
            label="Categoria da seção",
            :disabled="salvandoSecao",
            outlined,
            dense
          )
          v-textarea(
            :value="secaoManipulate.descricao",
            :disabled="salvandoSecao",
            @input="secaoManipulate.descricao = $event",
            label="Descrição",
            outlined,
            dense,
            rows="3",
            auto-grow
          )
          v-select(
            v-model="secaoManipulate.status",
            :items="opcoesStatusCategoria",
            label="Status",
            :disabled="salvandoSecao",
            outlined,
            dense
          )
          v-select(
            :value="secaoManipulate.ordenacaoArtigos",
            @input="secaoManipulate.ordenacaoArtigos = $event",
            :items="opcoesOrdenacaoArtigos",
            item-text="text",
            item-value="value",
            label="Ordenar artigos por",
            :disabled="salvandoSecao",
            outlined,
            dense
          )
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          @click="fecharSecao()",
          :disabled="salvandoSecao"
        ) Cancelar
        v-btn.faq-btn-primary.text-none(
          color="primary",
          small,
          type="submit",
          form="faq-form-secao",
          :loading="salvandoSecao",
          :disabled="salvandoSecao || carregandoEdicaoSecao"
        ) Salvar

  //- Dialog Confirmar Exclusão de Seção
  v-dialog(
    v-model="dialogConfirmacaoExclusaoSecao",
    persistent,
    max-width="500"
  )
    v-card.faq-card(outlined)
      v-card-title.faq-dialog-header Excluir seção
      v-card-text.pt-6
        p.mb-0 Tem certeza que deseja excluir a seção {{ secaoExclusaoPendente && secaoExclusaoPendente.titulo }}?
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          :disabled="excluindoSecao",
          @click="cancelarExclusaoSecao"
        ) Cancelar
        v-btn.text-none(
          color="error",
          small,
          :loading="excluindoSecao",
          :disabled="excluindoSecao",
          @click="confirmarExclusaoSecao"
        ) Excluir seção

  //- Dialog Adicionar artigos à seção
  v-dialog.faq-attach-articles-dialog(
    :value="dialogAnexarArtigos",
    @input="dialogAnexarArtigos = $event",
    persistent,
    max-width="600",
    max-height="calc(100vh - 48px)"
  )
    v-card.faq-card.faq-attach-articles-card(outlined)
      v-card-title.faq-dialog-header Adicionar artigos à seção
      v-card-text.pt-4
        p.mb-3(v-if="secaoAnexarArtigos") Seção: {{ secaoAnexarArtigos.titulo }}
        v-text-field.mb-2(
          v-model="buscaArtigosAnexar",
          label="Pesquisar artigos",
          prepend-inner-icon="mdi-magnify",
          outlined,
          dense,
          clearable,
          hide-details="auto"
        )
        .faq-attach-articles-empty(
          v-if="carregandoArtigosAnexar",
          role="status"
        )
          v-progress-circular(indeterminate, color="primary", size="28")
          span.ml-3 Carregando artigos...
        p.faq-attach-articles-empty.error--text(v-else-if="erroArtigosAnexar") {{ erroArtigosAnexar }}
        v-list.faq-attach-articles-list(
          dense,
          v-else-if="artigosFiltradosParaAnexar.length"
        )
          v-list-item(
            v-for="artigo in artigosFiltradosParaAnexar",
            :key="artigo.id"
          )
            v-list-item-action
              v-checkbox(
                :input-value="artigosJaNaSecaoIds.includes(artigo.id) || artigosAnexarIds.includes(artigo.id)",
                :disabled="vinculandoArtigos || artigosJaNaSecaoIds.includes(artigo.id)",
                :aria-label="artigosJaNaSecaoIds.includes(artigo.id) ? artigo.titulo + ' já está nesta seção' : 'Selecionar ' + artigo.titulo",
                hide-details,
                dense,
                @change="toggleArtigoAnexar(artigo.id, $event)"
              )
            v-list-item-content
              v-list-item-title {{ artigo.titulo }}
              v-list-item-subtitle(
                v-if="artigosJaNaSecaoIds.includes(artigo.id)"
              ) Já está nesta seção
        p.faq-attach-articles-empty.grey--text.font-italic(
          v-else-if="artigosDisponiveis.length"
        ) Nenhum artigo encontrado.
        p.mb-0.grey--text.font-italic(v-else) Não há artigos disponíveis para adicionar.
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          :disabled="vinculandoArtigos",
          @click="cancelarAnexarArtigos()"
        ) Cancelar
        v-btn.faq-btn-primary.text-none(
          color="primary",
          small,
          :disabled="vinculandoArtigos || artigosAnexarIds.length === 0",
          :loading="vinculandoArtigos",
          @click="confirmarAnexarArtigos()"
        ) Adicionar selecionados
  //- Dialog Confirmar Exclusão
  v-dialog(
    :value="dialogConfirmacaoExclusao",
    @input="dialogConfirmacaoExclusao = $event",
    persistent,
    max-width="500"
  )
    v-card.faq-card(outlined)
      v-card-title.faq-dialog-header Remover artigo da seção
      v-card-text.pt-6
        div
          | Esta ação remove o artigo somente desta seção, sem executar a exclusão global.
          .mt-8
            | Deseja remover
            strong {{ artigoExclusaoPendente && artigoExclusaoPendente.titulo }}
            | da seção
            strong {{ secaoDesvinculoPendente && secaoDesvinculoPendente.titulo }}?
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          :disabled="desvinculandoArtigo",
          @click="cancelarExclusaoArtigo()"
        ) Cancelar
        v-btn.text-none(
          color="error",
          small,
          :disabled="desvinculandoArtigo",
          :loading="desvinculandoArtigo",
          @click="confirmarExclusaoArtigo()"
        )
          span Remover da seção
</template>

<script>
import ordenarArtigosDaSecao from "@/utils/faq";
import { ordenacaoParaApi, ordenacaoParaInterface } from "@/utils/faqResumo";
import FaqStatus from "./FaqStatus.vue";
import { mensagemErroFaq } from "@/utils/faqErros";
import {
  buscarArtigosFaq,
  buscarCategoriaFaq,
  buscarSessaoFaq,
  criarCategoriaFaq,
  atualizarCategoriaFaq,
  excluirCategoriaFaq,
  criarSessaoFaq,
  atualizarSessaoFaq,
  excluirSessaoFaq,
  vincularArtigosSessaoFaq,
  desvincularArtigosSessaoFaq,
} from "@/api/faq";

const criarCategoriaFormulario = () => ({
  id: null,
  nome: "",
  descricao: "",
  status: "publicado",
});
const criarSecaoFormulario = (categoriaId = null) => ({
  id: null,
  nome: "",
  categoriaId,
  descricao: "",
  status: "publicado",
  ordenacaoArtigos: "relevancia",
});
export default {
  name: "FaqCategorias",
  components: { FaqStatus },
  props: {
    podeEditar: { type: Boolean, default: false },
    recarregarResumo: { type: Function, required: true },
    ativo: {
      type: Boolean,
      default: true,
    },
    dados: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      buscaArtigosAnexar: "",
      artigosDisponiveis: [],
      carregandoArtigosAnexar: false,
      erroArtigosAnexar: "",
      requisicaoArtigosAnexar: 0,
      carregandoCategorias: false,
      carregandoEdicaoCategoria: false,
      carregandoEdicaoSecao: false,
      requisicaoCategoria: 0,
      requisicaoSecao: 0,
      categoriaOriginal: null,
      secaoOriginal: null,
      salvandoCategoria: false,
      salvandoSecao: false,
      vinculandoArtigos: false,
      desvinculandoArtigo: false,
      excluindoSecao: false,
      dialogConfirmacaoExclusaoSecao: false,
      secaoDesvinculoPendente: null,
      excluindoCategoria: false,
      erroCategorias: "",
      dialogCategoria: false,
      dialogSecao: false,
      dialogAnexarArtigos: false,
      secaoAnexarArtigosId: null,
      artigosAnexarIds: [],
      dialogConfirmacaoExclusao: false,
      artigoExclusaoPendente: null,
      secaoExclusaoPendente: null,
      dialogConfirmacaoExclusaoCategoria: false,
      categoriaExclusaoPendente: null,
      categoriaManipulate: criarCategoriaFormulario(),
      opcoesStatusCategoria: [
        { text: "Publicado", value: "publicado" },
        { text: "Despublicado", value: "despublicado" },
      ],
      secaoManipulate: criarSecaoFormulario(),
      opcoesOrdenacaoArtigos: [
        {
          text: "Mais relevante",
          value: "relevancia",
        },
        {
          text: "Mais recente",
          value: "mais-recente",
        },
        {
          text: "Mais antigo",
          value: "mais-antigo",
        },
      ],
      categoriasExpandidas: [],
      secoesExpandidas: [],
      categoriasConhecidas: [],
      secoesConhecidas: [],
      busca: "",
    };
  },
  computed: {
    categoriasFiltradas() {
      const termo = this.normalizarTexto(this.busca);
      if (!termo) return this.categorias;
      return this.categorias.reduce((categorias, categoria) => {
        const categoriaCoincide = this.textoCorresponde(
          `${categoria.titulo || ""} ${categoria.descricao || ""}`,
          termo
        );
        const secoes = (categoria.secoes || []).reduce((resultado, secao) => {
          const secaoCoincide = this.textoCorresponde(
            `${secao.titulo || ""} ${secao.descricao || ""}`,
            termo
          );
          const artigos = secao.artigos || [];
          const artigosFiltrados = artigos.filter((artigo) =>
            this.textoCorresponde(artigo.titulo, termo)
          );
          if (secaoCoincide || artigosFiltrados.length) {
            resultado.push({
              ...secao,
              artigos: artigosFiltrados,
            });
          }
          return resultado;
        }, []);
        if (categoriaCoincide || secoes.length) {
          categorias.push({
            ...categoria,
            secoes,
          });
        }
        return categorias;
      }, []);
    },
    artigosFiltradosParaAnexar() {
      const termo = this.normalizarTexto(this.buscaArtigosAnexar);
      if (!termo) return this.artigosDisponiveis;
      return this.artigosDisponiveis.filter((artigo) =>
        this.normalizarTexto(artigo.titulo).includes(termo)
      );
    },
    categorias() {
      return this.dados.categorias;
    },
    secaoAnexarArtigos() {
      return this.getSecaoById(this.secaoAnexarArtigosId);
    },
    artigosJaNaSecaoIds() {
      return this.secaoAnexarArtigos
        ? this.secaoAnexarArtigos.artigos.map((artigo) => artigo.id)
        : [];
    },
  },
  watch: {
    categorias: {
      immediate: true,
      handler(categorias) {
        const categoriaIds = categorias.map((categoria) => categoria.id);
        const secaoIds = categorias.reduce(
          (ids, categoria) =>
            ids.concat(categoria.secoes.map((secao) => secao.id)),
          []
        );
        this.categoriasExpandidas = this.categoriasExpandidas.filter((id) =>
          categoriaIds.includes(id)
        );
        this.secoesExpandidas = this.secoesExpandidas.filter((id) =>
          secaoIds.includes(id)
        );
        categoriaIds
          .filter((id) => !this.categoriasConhecidas.includes(id))
          .forEach((id) => this.categoriasExpandidas.push(id));
        secaoIds
          .filter((id) => !this.secoesConhecidas.includes(id))
          .forEach((id) => this.secoesExpandidas.push(id));
        this.categoriasConhecidas = categoriaIds;
        this.secoesConhecidas = secaoIds;
      },
    },
    dialogAnexarArtigos(aberto) {
      if (aberto) this.buscaArtigosAnexar = "";
    },
  },
  methods: {
    expandirTudo() {
      this.categoriasExpandidas = this.categorias.map(
        (categoria) => categoria.id
      );
      this.secoesExpandidas = this.categorias.reduce((ids, categoria) => {
        categoria.secoes.forEach((secao) => ids.push(secao.id));
        return ids;
      }, []);
    },
    recolherTudo() {
      this.categoriasExpandidas = [];
      this.secoesExpandidas = [];
    },
    secaoTemArtigos(secao) {
      const original = this.getSecaoById(secao.id);
      return Boolean(original && original.artigos.length);
    },
    solicitarExclusaoSecao(secao) {
      const original = this.getSecaoById(secao.id);
      if (!original) return;
      if (original.artigos.length) {
        this.$toast.error(
          "Só é possível excluir uma seção sem artigos vinculados"
        );
        return;
      }
      this.secaoExclusaoPendente = original;
      this.dialogConfirmacaoExclusaoSecao = true;
    },
    cancelarExclusaoSecao() {
      if (this.excluindoSecao) return;
      this.dialogConfirmacaoExclusaoSecao = false;
      this.secaoExclusaoPendente = null;
    },
    async confirmarExclusaoSecao() {
      if (!this.podeEditar) return;
      if (this.excluindoSecao || !this.secaoExclusaoPendente) return;
      const secao = this.getSecaoById(this.secaoExclusaoPendente.id);
      if (!secao) {
        this.cancelarExclusaoSecao();
        return;
      }
      if (secao.artigos.length) {
        this.$toast.error(
          "Só é possível excluir uma seção sem artigos vinculados"
        );
        this.cancelarExclusaoSecao();
        return;
      }
      this.excluindoSecao = true;
      try {
        await excluirSessaoFaq(secao.id);
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.dialogConfirmacaoExclusaoSecao = false;
        this.secaoExclusaoPendente = null;
        this.$toast.success("Seção excluída com sucesso");
        await this.carregarCategorias();
      } catch (erro) {
        if (this._isDestroyed || this._isBeingDestroyed) return;
        if (erro.response && erro.response.status === 409) {
          this.dialogConfirmacaoExclusaoSecao = false;
          this.secaoExclusaoPendente = null;
          this.$toast.error(
            "Só é possível excluir uma seção sem artigos vinculados"
          );
          await this.carregarCategorias();
        } else {
          this.$toast.error(
            mensagemErroFaq(
              erro,
              "Não foi possível excluir a seção. Tente novamente."
            )
          );
        }
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.excluindoSecao = false;
      }
    },
    async carregarCategorias() {
      if (this.carregandoCategorias) return;
      this.carregandoCategorias = true;
      this.erroCategorias = "";
      try {
        await this.recarregarResumo(false);
        if (this._isDestroyed || this._isBeingDestroyed) return;
      } catch (erro) {
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.erroCategorias =
          "Não foi possível carregar as categorias e seções. Tente novamente.";
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.carregandoCategorias = false;
      }
    },
    categoriaTemSecoes(categoria) {
      const original = this.categorias.find((item) => item.id === categoria.id);
      return Boolean(original && original.secoes.length);
    },
    textoCorresponde(texto, termo) {
      return this.normalizarTexto(texto).includes(termo);
    },
    normalizarTexto(valor) {
      return (valor || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    artigosOrdenados(secao) {
      return ordenarArtigosDaSecao(secao);
    },
    categoriaExpandida(categoria) {
      return (
        Boolean(this.normalizarTexto(this.busca)) ||
        this.categoriasExpandidas.includes(categoria.id)
      );
    },
    secaoExpandida(secao) {
      return (
        Boolean(this.normalizarTexto(this.busca)) ||
        this.secoesExpandidas.includes(secao.id)
      );
    },
    alternarCategoria(categoria) {
      if (
        !this.categoriaTemSecoes(categoria) ||
        this.normalizarTexto(this.busca)
      )
        return;
      this.toggleCategoria(categoria);
    },
    alternarSecao(secao) {
      if (this.normalizarTexto(this.busca)) return;
      this.toggleSecao(secao);
    },
    novaCategoria() {
      if (!this.podeEditar) return;
      this.categoriaOriginal = null;
      this.categoriaManipulate = criarCategoriaFormulario();
      this.dialogCategoria = true;
    },
    novaSecao(categoria = null) {
      if (!this.podeEditar) return;
      this.secaoOriginal = null;
      this.secaoManipulate = criarSecaoFormulario(
        categoria ? categoria.id : null
      );
      this.dialogSecao = true;
    },
    fecharCategoria() {
      this.requisicaoCategoria += 1;
      this.carregandoEdicaoCategoria = false;
      this.dialogCategoria = false;
    },
    fecharSecao() {
      this.requisicaoSecao += 1;
      this.carregandoEdicaoSecao = false;
      this.dialogSecao = false;
    },
    async editarCategoria(categoria) {
      if (!this.podeEditar) return;
      const requisicao = ++this.requisicaoCategoria;
      this.categoriaOriginal = null;
      this.categoriaManipulate = {
        ...criarCategoriaFormulario(),
        id: categoria.id,
      };
      this.carregandoEdicaoCategoria = true;
      this.dialogCategoria = true;
      try {
        const completo = await buscarCategoriaFaq(categoria.id);
        if (
          this._isDestroyed ||
          this._isBeingDestroyed ||
          requisicao !== this.requisicaoCategoria
        )
          return;
        this.categoriaManipulate = {
          id: completo.id,
          nome: completo.nome || "",
          descricao: completo.descricao || "",
          status: completo.status,
        };
        this.categoriaOriginal = { ...this.categoriaManipulate };
      } catch (erro) {
        if (
          this._isDestroyed ||
          this._isBeingDestroyed ||
          requisicao !== this.requisicaoCategoria
        )
          return;
        this.fecharCategoria();
        this.$toast.error(
          mensagemErroFaq(
            erro,
            "Não foi possível carregar a categoria. Tente novamente."
          )
        );
      } finally {
        if (
          !this._isDestroyed &&
          !this._isBeingDestroyed &&
          requisicao === this.requisicaoCategoria
        )
          this.carregandoEdicaoCategoria = false;
      }
    },
    solicitarExclusaoCategoria(categoria) {
      categoria = this.categorias.find((item) => item.id === categoria.id);
      if (!categoria) return;
      if ((categoria.secoes || []).length > 0) {
        this.$toast.error(
          "Só é possível excluir uma categoria sem seções vinculadas"
        );
        return;
      }
      this.categoriaExclusaoPendente = categoria;
      this.dialogConfirmacaoExclusaoCategoria = true;
    },
    cancelarExclusaoCategoria() {
      if (this.excluindoCategoria) return;
      this.dialogConfirmacaoExclusaoCategoria = false;
      this.categoriaExclusaoPendente = null;
    },
    async confirmarExclusaoCategoria() {
      if (!this.podeEditar) return;
      if (this.excluindoCategoria) return;
      const categoriaPendente = this.categoriaExclusaoPendente;
      if (!categoriaPendente) return;
      const index = this.categorias.findIndex(
        (categoria) => categoria.id === categoriaPendente.id
      );
      if (index === -1) return;
      if ((this.categorias[index].secoes || []).length > 0) {
        this.$toast.error(
          "Só é possível excluir uma categoria sem seções vinculadas"
        );
        return;
      }
      this.excluindoCategoria = true;
      try {
        await excluirCategoriaFaq(categoriaPendente.id);
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.dialogConfirmacaoExclusaoCategoria = false;
        this.categoriaExclusaoPendente = null;
        this.$toast.success("Categoria excluída com sucesso");
        await this.carregarCategorias();
      } catch (erro) {
        if (this._isDestroyed || this._isBeingDestroyed) return;
        if (erro.response && erro.response.status === 409) {
          this.dialogConfirmacaoExclusaoCategoria = false;
          this.categoriaExclusaoPendente = null;
          this.$toast.error(
            "Só é possível excluir uma categoria sem seções vinculadas"
          );
          await this.carregarCategorias();
        } else {
          this.$toast.error(
            mensagemErroFaq(
              erro,
              "Não foi possível excluir a categoria. Tente novamente."
            )
          );
        }
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.excluindoCategoria = false;
      }
    },
    async editarSecao(categoria, secao) {
      if (!this.podeEditar) return;
      const requisicao = ++this.requisicaoSecao;
      this.secaoOriginal = null;
      this.secaoManipulate = { ...criarSecaoFormulario(), id: secao.id };
      this.carregandoEdicaoSecao = true;
      this.dialogSecao = true;
      try {
        const completo = await buscarSessaoFaq(secao.id);
        if (
          this._isDestroyed ||
          this._isBeingDestroyed ||
          requisicao !== this.requisicaoSecao
        )
          return;
        this.secaoManipulate = {
          id: completo.id,
          nome: completo.nome || "",
          categoriaId: completo.idfaqcategoria,
          descricao: completo.descricao || "",
          status: completo.status,
          ordenacaoArtigos: ordenacaoParaInterface(completo.ordenacao),
        };
        this.secaoOriginal = { ...this.secaoManipulate };
      } catch (erro) {
        if (
          this._isDestroyed ||
          this._isBeingDestroyed ||
          requisicao !== this.requisicaoSecao
        )
          return;
        this.fecharSecao();
        this.$toast.error(
          mensagemErroFaq(
            erro,
            "Não foi possível carregar a seção. Tente novamente."
          )
        );
      } finally {
        if (
          !this._isDestroyed &&
          !this._isBeingDestroyed &&
          requisicao === this.requisicaoSecao
        )
          this.carregandoEdicaoSecao = false;
      }
    },
    async salvarCategoria() {
      if (!this.podeEditar) return;
      if (this.salvandoCategoria || this.carregandoEdicaoCategoria) return;
      const titulo = (this.categoriaManipulate.nome || "").trim();
      const descricao = (this.categoriaManipulate.descricao || "").trim();
      const status = this.categoriaManipulate.status;
      if (!titulo) {
        this.$toast.error("Nome da categoria é obrigatório");
        return;
      }
      if (!["publicado", "despublicado"].includes(status)) {
        this.$toast.error("Selecione um status válido para a categoria");
        return;
      }
      const id = this.categoriaManipulate.id;
      const editando = id !== null;
      const alteracoes = {};
      if (editando) {
        const categoria = this.categoriaOriginal;
        if (!categoria) {
          this.$toast.error("Categoria não encontrada");
          return;
        }
        if (titulo !== categoria.nome) alteracoes.nome = titulo;
        if (descricao !== (categoria.descricao || ""))
          alteracoes.descricao = descricao;
        if (status !== categoria.status) alteracoes.status = status;
        if (Object.keys(alteracoes).length === 0) {
          this.dialogCategoria = false;
          return;
        }
      }
      this.salvandoCategoria = true;
      try {
        if (editando) {
          await atualizarCategoriaFaq(id, alteracoes);
        } else {
          await criarCategoriaFaq({ nome: titulo, descricao, status });
        }
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.dialogCategoria = false;
        this.categoriaManipulate = criarCategoriaFormulario();
        this.$toast.success(
          `Categoria ${editando ? "alterada" : "incluída"} com sucesso`
        );
        await this.carregarCategorias();
      } catch (erro) {
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.$toast.error(
          mensagemErroFaq(
            erro,
            `Não foi possível ${
              editando ? "alterar" : "incluir"
            } a categoria. Verifique os dados e tente novamente.`
          )
        );
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.salvandoCategoria = false;
      }
    },
    async salvarSecao() {
      if (!this.podeEditar) return;
      if (this.salvandoSecao || this.carregandoEdicaoSecao) return;
      const titulo = (this.secaoManipulate.nome || "").trim();
      const descricao = (this.secaoManipulate.descricao || "").trim();
      const ordenacao = ordenacaoParaApi(this.secaoManipulate.ordenacaoArtigos);
      if (!titulo) {
        this.$toast.error("Nome da seção é obrigatório");
        return;
      }
      const categoria = this.categorias.find(
        (item) => item.id === this.secaoManipulate.categoriaId
      );
      if (!categoria) {
        this.$toast.error("Selecione uma categoria");
        return;
      }
      if (!ordenacao) {
        this.$toast.error("Selecione uma ordenação válida");
        return;
      }
      const status = this.secaoManipulate.status;
      if (!["publicado", "despublicado"].includes(status)) {
        this.$toast.error("Selecione um status válido para a seção");
        return;
      }
      const id = this.secaoManipulate.id;
      const editando = id !== null;
      const alteracoes = {};
      if (editando) {
        const secao = this.secaoOriginal;
        if (!secao) {
          this.$toast.error("Seção não encontrada");
          return;
        }
        if (titulo !== secao.nome) alteracoes.nome = titulo;
        if (descricao !== (secao.descricao || ""))
          alteracoes.descricao = descricao;
        if (status !== secao.status) alteracoes.status = status;
        if (
          ordenacao !== ordenacaoParaApi(secao.ordenacaoArtigos || "relevancia")
        ) {
          alteracoes.ordenacao = ordenacao;
        }
        if (secao.categoriaId !== categoria.id)
          alteracoes.idfaqcategoria = categoria.id;
        if (Object.keys(alteracoes).length === 0) {
          this.dialogSecao = false;
          return;
        }
      }
      this.salvandoSecao = true;
      try {
        if (editando) {
          await atualizarSessaoFaq(id, alteracoes);
        } else {
          await criarSessaoFaq({
            idfaqcategoria: categoria.id,
            nome: titulo,
            descricao,
            ordenacao,
            status,
          });
        }
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.dialogSecao = false;
        this.secaoManipulate = criarSecaoFormulario();
        this.$toast.success(
          `Seção ${editando ? "alterada" : "incluída"} com sucesso`
        );
        await this.carregarCategorias();
      } catch (erro) {
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.$toast.error(
          mensagemErroFaq(
            erro,
            `Não foi possível ${
              editando ? "alterar" : "incluir"
            } a seção. Verifique os dados e tente novamente.`
          )
        );
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.salvandoSecao = false;
      }
    },
    toggleCategoria(categoria) {
      const index = this.categoriasExpandidas.indexOf(categoria.id);
      if (index === -1) {
        this.categoriasExpandidas.push(categoria.id);
      } else {
        this.categoriasExpandidas.splice(index, 1);
      }
    },
    toggleSecao(secao) {
      const index = this.secoesExpandidas.indexOf(secao.id);
      if (index === -1) {
        this.secoesExpandidas.push(secao.id);
      } else {
        this.secoesExpandidas.splice(index, 1);
      }
    },
    getSecaoById(secaoId) {
      for (const categoria of this.categorias) {
        const secao = categoria.secoes.find((item) => item.id === secaoId);
        if (secao) return secao;
      }
      return null;
    },
    async abrirDialogAnexarArtigos(secao) {
      const requisicao = ++this.requisicaoArtigosAnexar;
      this.secaoAnexarArtigosId = secao.id;
      this.artigosAnexarIds = [];
      this.artigosDisponiveis = [];
      this.erroArtigosAnexar = "";
      this.carregandoArtigosAnexar = true;
      this.dialogAnexarArtigos = true;
      try {
        const artigos = await buscarArtigosFaq(false);
        if (
          this._isDestroyed ||
          this._isBeingDestroyed ||
          requisicao !== this.requisicaoArtigosAnexar
        )
          return;
        if (!Array.isArray(artigos))
          throw new Error("Formato inválido na lista de artigos");
        this.artigosDisponiveis = artigos;
      } catch (erro) {
        if (
          !this._isDestroyed &&
          !this._isBeingDestroyed &&
          requisicao === this.requisicaoArtigosAnexar
        ) {
          this.erroArtigosAnexar =
            "Não foi possível carregar os artigos. Feche e tente novamente.";
        }
      } finally {
        if (
          !this._isDestroyed &&
          !this._isBeingDestroyed &&
          requisicao === this.requisicaoArtigosAnexar
        )
          this.carregandoArtigosAnexar = false;
      }
    },
    toggleArtigoAnexar(artigoId, selecionado) {
      const secao = this.getSecaoById(this.secaoAnexarArtigosId);
      if (!secao || secao.artigos.some((artigo) => artigo.id === artigoId))
        return;
      const index = this.artigosAnexarIds.indexOf(artigoId);
      if (selecionado && index === -1) {
        this.artigosAnexarIds.push(artigoId);
      } else if (!selecionado && index !== -1) {
        this.artigosAnexarIds.splice(index, 1);
      }
    },
    cancelarAnexarArtigos() {
      if (this.vinculandoArtigos) return;
      this.requisicaoArtigosAnexar += 1;
      this.dialogAnexarArtigos = false;
      this.secaoAnexarArtigosId = null;
      this.artigosAnexarIds = [];
    },
    async confirmarAnexarArtigos() {
      if (!this.podeEditar) return;
      if (!this.dialogAnexarArtigos || this.vinculandoArtigos) return;
      const secao = this.getSecaoById(this.secaoAnexarArtigosId);
      if (!secao) {
        this.cancelarAnexarArtigos();
        this.$toast.error("A seção não foi encontrada");
        return;
      }
      const idsJaVinculados = new Set(secao.artigos.map((artigo) => artigo.id));
      const selecionados = this.artigosDisponiveis.filter(
        (item) =>
          this.artigosAnexarIds.includes(item.id) &&
          !idsJaVinculados.has(item.id)
      );
      if (selecionados.length === 0) return;
      const idsartigos = [...new Set(selecionados.map((item) => item.id))];
      this.vinculandoArtigos = true;
      try {
        const resposta = await vincularArtigosSessaoFaq(secao.id, idsartigos);
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.dialogAnexarArtigos = false;
        this.secaoAnexarArtigosId = null;
        this.artigosAnexarIds = [];
        const quantidade =
          resposta.quantidade != null
            ? resposta.quantidade
            : (resposta.idsartigos || []).length;
        this.$toast.success(
          `${quantidade} artigo(s) adicionado(s) à seção com sucesso`
        );
        await this.carregarCategorias();
      } catch (erro) {
        if (!this._isDestroyed && !this._isBeingDestroyed) {
          this.$toast.error(
            mensagemErroFaq(
              erro,
              "Não foi possível adicionar os artigos à seção. Verifique os dados e tente novamente."
            )
          );
        }
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.vinculandoArtigos = false;
      }
    },
    solicitarExclusaoArtigo(secao, artigo) {
      this.secaoDesvinculoPendente = this.getSecaoById(secao.id);
      this.artigoExclusaoPendente = artigo;
      this.dialogConfirmacaoExclusao = true;
    },
    cancelarExclusaoArtigo() {
      if (this.desvinculandoArtigo) return;
      this.dialogConfirmacaoExclusao = false;
      this.secaoDesvinculoPendente = null;
      this.artigoExclusaoPendente = null;
    },
    async confirmarExclusaoArtigo() {
      if (!this.podeEditar) return;
      if (this.desvinculandoArtigo) return;
      const secao =
        this.secaoDesvinculoPendente &&
        this.getSecaoById(this.secaoDesvinculoPendente.id);
      const artigo = this.artigoExclusaoPendente;
      if (!secao || !artigo) return;
      this.desvinculandoArtigo = true;
      try {
        await desvincularArtigosSessaoFaq(secao.id, [artigo.id]);
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.dialogConfirmacaoExclusao = false;
        this.secaoDesvinculoPendente = null;
        this.artigoExclusaoPendente = null;
        this.$toast.success("Artigo removido da seção com sucesso");
        await this.carregarCategorias();
      } catch (erro) {
        if (!this._isDestroyed && !this._isBeingDestroyed) {
          if (erro.response && erro.response.status === 409) {
            this.$toast.error(
              "O artigo precisa estar em pelo menos uma seção. Adicione-o a outra seção antes de removê-lo desta."
            );
          } else {
            this.$toast.error(
              mensagemErroFaq(
                erro,
                "Não foi possível remover o artigo da seção. Tente novamente."
              )
            );
          }
        }
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.desvinculandoArtigo = false;
      }
    },
  },
  mounted() {
    this.carregarCategorias();
  },
};
</script>
